import React, { JSX } from "react";
import GlobalStyle from "../../styles/GlobalStyle";
import {
  scaleModerate,
  scaleHorizontal,
  FontSizes,
} from "../../styles/responsive";
import { V2ReportStyle } from "../../styles/V2ReportStyle";
import { healthSetGoCare } from "../../Assets/images";
import { UserIconSvg } from "../../utils/Svgs";
import { Session } from "inspector";

const StudentCard = ({
  icon = <UserIconSvg />,
  name,
  schoolName,
  padding = 5,
  docSignature,
}: {
  icon?: JSX.Element;
  name: string;
  schoolName: string;
  padding?: number;
  docSignature?: string;
}) => {
  const organizationName = sessionStorage.getItem("organizationName");

  return (
    <div style={{ ...V2ReportStyle.card, padding: "2rem 2rem" }}>
      <div style={{ ...V2ReportStyle.flexRowCenter, gap: scaleHorizontal(5) }}>
        <div style={V2ReportStyle.cardWithBg}>{icon}</div>
        <div style={V2ReportStyle.flexColumnCenter}>
          <span style={{ ...GlobalStyle.blackBoldText, fontSize: "2.2rem" }}>
            {name}
          </span>
          {organizationName && (
            <span
              style={{
                ...GlobalStyle.blackMediumText,
                fontSize: "1.8rem",
              }}
            >
              {organizationName}
            </span>
          )}
        </div>
        <img
          src={healthSetGoCare}
          alt="HealthSetGo Logo"
          style={{
            ...V2ReportStyle.logoDimension,
            width: "auto",
            maxHeight: "50px",
            objectFit: "contain",
            flexShrink: 0,
            display: "block",
          }}
        />
      </div>
    </div>
  );
};

export default StudentCard;
